
    import './styles.scoped.css';
    export default {
  "root": "awsui_root_4yi2u_1qk0m_93",
  "outline": "awsui_outline_4yi2u_1qk0m_107",
  "toggle-control": "awsui_toggle-control_4yi2u_1qk0m_126",
  "toggle-control-checked": "awsui_toggle-control-checked_4yi2u_1qk0m_135",
  "toggle-control-disabled": "awsui_toggle-control-disabled_4yi2u_1qk0m_138",
  "toggle-handle": "awsui_toggle-handle_4yi2u_1qk0m_145",
  "toggle-handle-checked": "awsui_toggle-handle-checked_4yi2u_1qk0m_157",
  "toggle-handle-disabled": "awsui_toggle-handle-disabled_4yi2u_1qk0m_160"
};
  